import * as React from 'react'
import Icon from '../Icon/Icon'

export interface IEditResponseProps {
  functionEdit: any
  alt?: string
}

// {functionEdit, alt} is a destructuration from the props
const EditResponse = ({ functionEdit, alt }: IEditResponseProps) => {
  return (
    <div className="EditResponse">
      <button type="button" onClick={functionEdit}>
        <Icon name="edition" alt={alt ? alt : 'Editer cette reponse'} />
      </button>
    </div>
  )
}

export default EditResponse



// WEBPACK FOOTER //
// ./src/components/EditResponse/EditResponse.tsx